import { use } from 'react';

import { TenantSelectionContext } from 'contexts/TenantSelectionContext';
import { tenantScopedKey } from 'utils/tenantCacheKey';

/**
 * Scopes an SWR cache key to the selected tenant, so a tenant switch can never serve the previous
 * tenant's cached response. See utils/tenantCacheKey for the key shape and the imperative
 * equivalent used by cache writes.
 *
 * Returns null until a tenant is selected, which tells SWR not to fetch — these endpoints require
 * the X-Tenant-Id header and would be rejected anyway. Also returns null when `url` is null, so
 * callers can keep using that to defer a fetch.
 *
 * Do not use for catalog-wide data (tenants, pages, roles, permissions): those are the same for
 * every tenant, and scoping them would refetch needlessly and stop the tenant list loading before
 * a tenant has been chosen.
 */
export default function useTenantScopedKey(url: string | null): string | null {
  const tenantId = use(TenantSelectionContext)?.tenantId ?? null;

  return tenantScopedKey(url, tenantId);
}
